module.exports = __webpack_public_path__ + "img/13.9f28208e.png";